export default {
  headermenu: require('./headermenu'),
  rolechannel: require('./rolechannel')
}
